/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source SVG file at
 * `src/shared/joykit/packages/core/icons/svgs/<SIZE>/profile.svg`, and run `yarn icon:codegen` to regenerate this file.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Profile',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.8779 17.8601C19.3747 16.3588 20.3 14.2875 20.3 12C20.3 7.41604 16.584 3.7 12 3.7C7.41604 3.7 3.7 7.41604 3.7 12C3.7 14.2874 4.62529 16.3587 6.12199 17.8599C6.41806 16.9445 6.95512 16.1066 7.69149 15.4277C8.26177 14.9019 8.92899 14.4919 9.65213 14.2118C8.55646 13.462 7.8375 12.202 7.8375 10.7741C7.8375 8.47526 9.70111 6.61164 12 6.61164C14.2989 6.61164 16.1625 8.47526 16.1625 10.7741C16.1625 12.2021 15.4435 13.462 14.3478 14.2118C15.079 14.495 15.7529 14.911 16.3272 15.4451C17.0542 16.1213 17.5845 16.9528 17.8779 17.8601ZM18.1347 19.2539C20.1932 17.5113 21.5 14.9083 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5C13.8101 21.5 15.5019 20.9938 16.9417 20.1152C16.9691 20.0984 16.9964 20.0816 17.0236 20.0646C17.4138 19.821 17.7851 19.5499 18.1347 19.2539ZM16.8642 18.726C16.6894 17.8275 16.2232 16.9872 15.51 16.3239C14.586 15.4646 13.3241 14.975 12 14.975C10.6834 14.9749 9.42778 15.459 8.50492 16.3099C7.78353 16.9751 7.31174 17.8207 7.13564 18.7259C8.5025 19.7162 10.1831 20.3 12 20.3C13.8169 20.3 15.4974 19.7162 16.8642 18.726ZM12 7.81164C10.3639 7.81164 9.0375 9.138 9.0375 10.7741C9.0375 12.4103 10.3639 13.7366 12 13.7366C13.6361 13.7366 14.9625 12.4103 14.9625 10.7741C14.9625 9.138 13.6361 7.81164 12 7.81164Z"
            fill="currentColor"
          />
        </>
      )
    }
  }
};

const icon = createSvgIcon(config);
export default icon;
